import $ from 'jquery';

$(() => {
  $('.member-full-bio, .bio-minus').hide();

  $('.bio-toggle').on('click', function toggleBio(event) {
    event.preventDefault();
    $(this).closest('.grid-row').find('.member-full-bio, .bio-plus, .bio-minus').toggle();
  });
});
